"use strict";

exports.__esModule = true;
exports.loadScript = void 0;
var id = 0;
var scripstMap = new Map();
var loadScript = exports.loadScript = function (global) {
  return function (scripts) {
    var Cache = {};
    Cache._onLoad = function (key) {
      return function (cb) {
        var stored = scripstMap.get(key);
        if (stored) {
          stored.promise.then(function () {
            if (stored.error) {
              return cb(stored.error);
            }
            cb(null, stored);
          });
        } else {
          // eslint-disable-next-line no-console
          console.warn('No script cached');
        }
      };
    };
    Cache._scriptTag = function (key, src) {
      if (!scripstMap.has(key)) {
        var tag = document.createElement('script');
        var promise = new Promise(function (resolve, reject) {
          var body = document.getElementsByTagName('body')[0];
          tag.type = 'text/javascript';
          tag.async = true;
          tag.defer = true;
          var cbName = "loaderCB" + (id += 1) + Date.now();
          var cleanup = function cleanup() {
            if (global[cbName] && typeof global[cbName] === 'function') {
              // eslint-disable-next-line no-param-reassign
              global[cbName] = null;
            }
          };
          var handleResult = function handleResult(state) {
            return function (evt) {
              var stored = scripstMap.get(key);
              if (state === 'loaded') {
                stored.resolved = true;
                resolve(src);
              } else if (state === 'error') {
                stored.errored = true;
                reject(evt);
              }
              cleanup();
            };
          };
          tag.onload = handleResult('loaded');
          tag.onerror = handleResult('error');
          tag.onreadystatechange = function () {
            handleResult(tag.readyState);
          };
          if (src.match(/callback=CALLBACK_NAME/)) {
            // eslint-disable-next-line no-param-reassign
            src = src.replace(/(callback=)[^&]+/, "$1" + cbName);
            // eslint-disable-next-line no-multi-assign, no-param-reassign
            global[cbName] = tag.onload;
          } else {
            tag.addEventListener('load', tag.onload);
          }
          tag.addEventListener('error', tag.onerror);
          tag.src = src;
          body.appendChild(tag);
          return tag;
        });
        var initialState = {
          loaded: false,
          error: false,
          promise: promise,
          tag: tag
        };
        scripstMap.set(key, initialState);
      }
      return scripstMap.get(key);
    };
    Object.keys(scripts).forEach(function (key) {
      var script = scripts[key];
      Cache[key] = {
        tag: Cache._scriptTag(key, script),
        onLoad: Cache._onLoad(key)
      };
    });
    return Cache;
  };
}(typeof window !== 'undefined' ? window : global);